import React, { useState, useEffect } from 'react';
import { Box, Tabs } from '@mantine/core';
import { IconForms, IconFileTypePdf, IconBook2 } from '@tabler/icons-react';
import AgentTemplateCreator from './AgentTemplateCreator';
import DiagramWizard from './DiagramWizard';
import KbAgentBuilder from './KbAgentBuilder';
import Footer from '../../components/Footer';

// Feature-flag for the KB-driven "From KB" tab. Same flag the SIT KB importer
// reads — sourced from `REACT_APP_ENABLE_KB_FEATURES` (build-time, populated
// from SSM `/presidio-cc-tools/{env}/enable-kb-features`). Default false so
// any env that hasn't opted in stays safe.
const KB_FEATURES_ENABLED = process.env.REACT_APP_ENABLE_KB_FEATURES === 'true';

// v2: two tabs.
//   "From Form"    — original AgentTemplateCreator (single-bot, form-driven).
//   "From Diagram" — DiagramWizard (multi-bot + WxCC flow, PDF-driven).
//
// CLAUDE.md previously called for a Hub pattern when adding new tools; per
// user direction (auto-mode session 2026-06-01) we ship Tabs instead — both
// tabs are first-class entry points for AgentStudio.
//
// Note: both Tabs.Panel children stay mounted (Mantine default). This avoids
// the focus-induced scroll-to-bottom when the active panel mounts. The wizard's
// listTenantProfiles call on mount is cheap (one Scan).
function AgentStudioApp({ onBackToPlatformSelector, platformInfo }) {
  const [activeTab, setActiveTab] = useState('form');

  // Reset scroll on mount — App.js state-swaps platform components without a
  // route change, so the previous scroll position carries over and can land
  // the user past the Tabs.List, looking like an auto-scroll to the bottom.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box style={{ flex: 1 }}>
        <Tabs value={activeTab} onChange={setActiveTab} color="cyan">
          <Tabs.List px="xl" pt="md" style={{ borderBottom: '1px solid #e9ecef', background: '#ffffff' }}>
            <Tabs.Tab value="form" leftSection={<IconForms size={16} />}>From Form</Tabs.Tab>
            <Tabs.Tab value="diagram" leftSection={<IconFileTypePdf size={16} />}>From Diagram</Tabs.Tab>
            {KB_FEATURES_ENABLED && (
              <Tabs.Tab value="kb" leftSection={<IconBook2 size={16} />}>From KB</Tabs.Tab>
            )}
          </Tabs.List>
          <Tabs.Panel value="form">
            <AgentTemplateCreator
              onBackToPlatformSelector={onBackToPlatformSelector}
              platformInfo={platformInfo}
            />
          </Tabs.Panel>
          <Tabs.Panel value="diagram">
            <DiagramWizard
              onBackToPlatformSelector={onBackToPlatformSelector}
              platformInfo={platformInfo}
            />
          </Tabs.Panel>
          {KB_FEATURES_ENABLED && (
            <Tabs.Panel value="kb">
              <KbAgentBuilder
                onBackToPlatformSelector={onBackToPlatformSelector}
                platformInfo={platformInfo}
              />
            </Tabs.Panel>
          )}
        </Tabs>
      </Box>
      <Footer platformColor="cyan" />
    </Box>
  );
}

export default AgentStudioApp;
